/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-app-level-alert';
const prefix = `${moduleName}.${componentName}`;

export const defaultActionBtnLabel = `${prefix}.defaultActionBtnLabel`;
export const viewDetailsLabel = `${prefix}.viewDetailsLabel`;
export const goToEventLabel = `${prefix}.goToEventLabel`;

export const ENGLISH = {
    [defaultActionBtnLabel]: 'Click',
    [viewDetailsLabel]: 'View Details',
    [goToEventLabel]: 'Go To Events',
};
